import Product from '~/Api/Product/Product';

import ProductList from './ProductList';

export default class Item {
	product: Product;

	memberOfLists: ProductList[];

	constructor(product: Product, memberOfLists: ProductList[]) {
		this.product = product;
		this.memberOfLists = memberOfLists;
	}

	memberOfListsAdded(list: ProductList): Item {
		const memberOfLists = [...this.memberOfLists, list];
		memberOfLists.sort((a, b) => a.name.localeCompare(b.name));
		return new Item(this.product, memberOfLists);
	}

	memberOfListsHasListWithId(id: string): boolean {
		return this.memberOfLists.find((list) => list.id === id) !== undefined;
	}
}
